import { Link } from 'react-router-dom'
import useBriefContext from '../../Hooks/Brief/useBriefContext'
import { BIZ_EMAIL_PATH } from '../../Router/Routes/formRoutes'
import './BizLoginBanner.less'
import isGuestAuthenticated from '../../Logic/Guest/isGuestAuthenticated'
import useLayout from '../../Hooks/Layout/Base/useLayout'

const BizLoginBanner = (): JSX.Element | null => {
  const { brief } = useBriefContext()
  const { currentLayout } = useLayout()
  const showBizLayout = currentLayout === 'biz'
  if (isGuestAuthenticated(brief)) return null
  if (showBizLayout) return null
  return (
    <p className='biz-login-banner'>
      <span className='prefix'>Are you a</span> HeadBox Business customer?{' '}
      <Link to={`/${BIZ_EMAIL_PATH}`} className='sign-in-link'>
        Sign in
      </Link>
    </p>
  )
}

export default BizLoginBanner
